import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { bidangDummy } from "../../../../types/dataBidang";
import SkeletonGrid from "../../../Components/loading/skeletonAspirasi";

const Aspirasi = () => {
  const [presidenList, setPresidenList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [bidang, setBidang] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);

  const navigate = useNavigate();

  const fetchPresiden = async (page: number = 1) => {
    setLoading(true);
    try {
      const token = Cookies.get("token");
      let url = `${process.env.REACT_APP_API_BASE_URL}/api/presiden?per_page=12&page=${page}`;

      if (search) url += `&search=${encodeURIComponent(search)}`;
      if (bidang) url += `&bidang[]=${encodeURIComponent(bidang)}`;

      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setPresidenList(res.data.data);
      setCurrentPage(res.data.current_page);
      setLastPage(res.data.last_page);
    } catch (err) {
      console.error("Gagal ambil data presiden:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPresiden();
  }, [search, bidang]);

  return (
    <div className="mt-7">
      <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-4 gap-3">
        <h2 className="text-xl font-bold">Aspirasi</h2>

        <div className="flex gap-3">
          <input type="text" placeholder="Search..." value={search} onChange={(e) => setSearch(e.target.value)} className="border px-3 py-2 rounded " />
          <select value={bidang} onChange={(e) => setBidang(e.target.value)} className="border px-3 py-2 rounded max-w-xs">
            <option value="">Semua Bidang</option>
            {bidangDummy.map((b) => (
              <option key={b.id} value={b.nama}>
                {b.nama}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Grid Card */}
      {loading ? (
        <div className="text-center py-10">
          {" "}
          <SkeletonGrid />
        </div>
      ) : presidenList.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {presidenList.map((item) => (
            <div key={item.id} className="cursor-pointer border rounded-xl shadow hover:shadow-lg transition p-4 flex flex-col items-center text-center">
              <img src={item.foto} alt={item.nama} className="w-40 h-52 object-cover rounded border-4 border-yellow-400" />
              <h3 className="mt-3 font-bold text-lg">{item.nama}</h3>
              <p className="text-gray-600">{item.jabatan}</p>

              <div onClick={() => navigate(`/dashboard/aspirasi/detail/${item.id}`)} className="flex justify-center bg-primary rounded-lg px-6 py-2 text-white mt-3">
                Lihat Aspirasi
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-10">Data tidak tersedia</div>
      )}

      {/* Pagination */}
      <div className="flex justify-end gap-4 items-center mt-6">
        <button className="px-4 py-2 bg-black2 text-white rounded disabled:opacity-50" onClick={() => fetchPresiden(currentPage - 1)} disabled={currentPage === 1 || loading}>
          Prev
        </button>
        <div className="px-4 py-2 border border-black2 text-black2 rounded">
          <span>
            Page {currentPage} dari {lastPage}
          </span>
        </div>
        <button className="px-4 py-2 bg-black2 text-white rounded disabled:opacity-50" onClick={() => fetchPresiden(currentPage + 1)} disabled={currentPage === lastPage || loading}>
          Next
        </button>
      </div>
    </div>
  );
};

export default Aspirasi;
